import _ from 'lodash';
import moment from 'moment';
import { CONFIG } from '../config';
import { ContextEnum } from '../enuns/context.enum';

export const environment = {
    _getContextEnum(idLayer) {
        idLayer = idLayer.toLowerCase();
        switch (true) {
            case idLayer.indexOf('dealerships') >= 0:
                return ContextEnum.LayerNetwork;

            case idLayer.indexOf('competitors') >= 0:
                return ContextEnum.LayerCompetitors;

            case idLayer.indexOf('storeinactive') >= 0:
                return ContextEnum.LayerInactiveStore;

            case idLayer.indexOf('storeplanned') >= 0:
                return ContextEnum.LayerPlannedStore;

            case idLayer.indexOf('clustersales') >= 0:
                return ContextEnum.LayerClusterSales;

            case idLayer.indexOf('directsales') >= 0:
                return ContextEnum.LayerDirectSale;

            case idLayer.indexOf('pointofinterest') >= 0:
                return ContextEnum.LayerPointInterest;

            case idLayer.indexOf('greenfield') >= 0:
                return ContextEnum.LayerGreenfield;

            case idLayer.indexOf('brownfield') >= 0:
                return ContextEnum.LayerBrownfield;

            case idLayer.indexOf('customers') >= 0:
                return ContextEnum.LayerCustomer;

            case idLayer.indexOf('selectedareas') >= 0:
                return ContextEnum.LayerLocales;

            case idLayer.indexOf('areaclient') >= 0:
            case idLayer.indexOf('markedarea') >= 0:
                return ContextEnum.LayerLocalesClient;

            case idLayer.indexOf('dnc') >= 0:
                return ContextEnum.LayerDncFlexible;

            case idLayer.indexOf('networkaftersales') >= 0:
                return ContextEnum.LayerNetworkAfterSales;

            case idLayer.indexOf('customersaftersales') >= 0:
                return ContextEnum.LayerCustomersAfterSales;

            case idLayer.indexOf('storeareasaftersales') >= 0:
                return ContextEnum.LayerStoreAreasAfterSales;

            case idLayer.indexOf('markedareaaftersales') >= 0:
                return ContextEnum.LayerMarkedAreaAfterSales;

            case idLayer.indexOf('greenfieldaftersales') >= 0:
                return ContextEnum.LayerGreenfieldAfterSales;

            case idLayer.indexOf('selectedareasaftersales') >= 0:
                return ContextEnum.LayerSelectedAreasAfterSales;

            case idLayer.indexOf('competitorsaftersales') >= 0:
                return ContextEnum.LayerCompetitorsAfterSales;

            case idLayer.indexOf('storeinactiveaftersales') >= 0:
                return ContextEnum.LayerInactiveStoreAfterSales;

            case idLayer.indexOf('pgts') >= 0:
                return ContextEnum.LayerPgts;

            case idLayer.indexOf('voronoi') >= 0:
                return ContextEnum.LayerVoronoi;

            default:
                return ContextEnum.PanelSuperior;
        }
    },

    _getDate(date, type, format) {
        let res;

        if (_.isDate(date)) {
            res = moment(date);
        } else if (_.isString(date)) {
            res = moment(date, (date.length === 4 ? 'YYYY' : 'YYYYMM'));
        } else {
            if (this.has('CONFIG.FILTERS.DATE_PREFERENCES.SUMMARY')) {
                res = moment(this.get(`CONFIG.FILTERS.DATE_PREFERENCES.SUMMARY.${type}`));
            } else {
                res = moment(this.get(`CONFIG.FILTERS.${type}YEAR`));
            }
            res = type === 'END' ? res.endOf('year') : res.startOf('year');
        }

        if (type === 'END' && this.has(`CONFIG.FILTERS.${type}YEAR`) && (res.toDate().getTime() > this.get(`CONFIG.FILTERS.${type}YEAR`).getTime())) {
            res = moment(this.get(`CONFIG.FILTERS.${type}YEAR`));
        } else if (type === 'START' && this.has(`CONFIG.FILTERS.${type}YEAR`) && (res.toDate().getTime() < this.get(`CONFIG.FILTERS.${type}YEAR`).getTime())) {
            res = moment(this.get(`CONFIG.FILTERS.${type}YEAR`));
        }

        if (format) {
            return res.format(format);
        }

        return res;
    },

    remove(value) {
        this.set(value, undefined);
    },

    set(key, values) {
        CONFIG.URL[key] = values;
    },

    get(value) {
        return _.get(CONFIG, value) || _.get(CONFIG.URL, value);
    },

    has(value) {
        return _.has(CONFIG, value) || _.has(CONFIG.URL, value);
    },

    validate: (() => {
        const validate = {
            date(date) {
                return moment(date);
            }
        };

        validate.date.start = (date, format) => {
            return environment._getDate(date, 'START', format);
        };

        validate.date.end = (date, format) => {
            return environment._getDate(date, 'END', format);
        };

        return validate;
    })(),

    getAll() {
        return CONFIG;
    },

    find(prop, value) {
        return _.find(CONFIG, (val) => val[prop] === value);
    }
};

export default environment;



// WEBPACK FOOTER //
// ./src/scripts/environment.js